'use client'

import CkEditorCSRRendererInner from '@/components/elementary/CkEditorRenderer/CkEditorCSRRendererInner'
import type { CkEditorRendererProps } from '@/components/elementary/CkEditorRenderer/types'
import { ErrorBoundary } from '@/components/elementary/ErrorBoundary'
import './CkEditorDefaultStyles.css'
import { useTranslations } from 'next-intl'

/**
 * Use this variant of the CkEditorRenderer whenever you are within the client context. That means you will need to validate that the entire
 * tree in which this component is being rendered.
 */
const CkEditorCSRRenderer = (props: CkEditorRendererProps) => {
	const t = useTranslations('CkEditorRenderer')
	return (
		<ErrorBoundary customErrorTitle={t('error')} hideReset>
			<CkEditorCSRRendererInner {...props} />
		</ErrorBoundary>
	)
}

export default CkEditorCSRRenderer
